<template>
	<div class="logs">
		<div class="vx-card">
			<div class="vx-row p-4 gap-5 lg:gap-0">
				<div class="vx-col lg:w-1/2 w-full">
					<v-select
						v-model="selectedManagers"
						:placeholder="$t('managers')"
						:options="managers"
						class="w-full mr-8"
						label="name"
						clearable
						multiple
					>
						<template #footer>
							<div class="d-flex justify-between w-full">
								<vs-button
									size="small"
									type="line"
									color="primary"
									class="pl-3 pr-3"
									@click="selectAllManagers"
								>
									{{ $t("all") }}
								</vs-button>

								<vs-button
									size="small"
									type="line"
									color="primary"
									class="pl-3 pr-3"
									@click="cleanSelectedManagers"
								>
									{{ $t("clean") }}
								</vs-button>
							</div>
						</template>
					</v-select>
				</div>

				<div class="vx-col lg:w-1/2 w-full">
					<div
						class="d-flex w-full gap-5 datepicker-widget-block sm:flex-no-wrap flex-wrap"
					>
						<div class="vx-col datepickers">
							<div
								class="vs-component vs-con-input-label vs-input vs-input-primary vx-col w-auto mb-5"
							>
								<div class="vs-con-input"></div>
								<vs-datepicker
									v-model="off"
									format="dd.MM.yyyy"
									:placeholder="$t('from')"
									name="date"
									class="w-full xl:w-auto tickets__datepicker"
								></vs-datepicker>
							</div>

							<div
								class="vs-component vs-con-input-label vs-input vs-input-primary vx-col w-auto"
							>
								<div class="vs-con-input"></div>
								<vs-datepicker
									v-model="to"
									format="dd.MM.yyyy"
									:placeholder="$t('to')"
									name="date"
									class="w-full xl:w-auto tickets__datepicker"
								></vs-datepicker>
							</div>
						</div>

						<div class="vx-col w-full widget">
							<vx-card class="info-card">
								<div
									class="flex justify-between items-center box-top h-full"
								>
									<div class="des w-full">
										<p class="info-card__title">
											{{ $t("totalActions") }}
										</p>

										<span class="info-card__value">
											{{ totalActions }}
										</span>
									</div>

									<div class="icon icon_green ml-3">
										<feather-icon
											color="#3AC47D"
											icon="ActivityIcon"
										></feather-icon>
									</div>
								</div>
							</vx-card>
						</div>
					</div>
				</div>
			</div>

			<div class="vx-row w-full justify-between m-0 mb-4">
				<div class="vx-col w-full my-4">
					<v-select
						v-model="selectedManagersActions"
						:placeholder="$t('actions')"
						:options="filteredActions"
						class="w-full actions-select"
						label="title"
						clearable
						multiple
					>
						<template #footer>
							<div class="d-flex justify-between w-full">
								<vs-button
									size="small"
									type="line"
									color="primary"
									class="pl-3 pr-3"
									@click="selectAllManagersActions"
								>
									{{ $t("all") }}
								</vs-button>

								<vs-button
									size="small"
									type="line"
									color="primary"
									class="pl-3 pr-3"
									@click="cleanSelectedManagersActions"
								>
									{{ $t("clean") }}
								</vs-button>
							</div>
						</template>
					</v-select>
				</div>

				<div class="vx-row w-full my-2 justify-end">
					<template>
						<vs-custom-button
							color="dark"
							type="border"
							@click="resetFilters"
							>{{ $t("reset") }}
						</vs-custom-button>
					</template>
				</div>
			</div>
		</div>

		<div class="table w-full vx-card">
			<div class="w-1/6 m-3 vx-row w-full">
				<div class="perPage">
					<v-select
						class="selectExample"
						v-model="maxItems"
						:searchable="false"
						:clearable="false"
						:options="[10, 20, 50]"
					/>
				</div>

				<div class="search flex items-center ml-3">
					<vs-input
						icon-after
						:placeholder="$t('searchById')"
						v-on:icon-click="searchById"
						v-model="orderId"
						class="w-full"
						v-on:keyup.enter="searchById"
						@input="searchById"
					/>
					<vs-icon
						icon="search"
						@click="searchById"
						class="search-icon"
					/>
				</div>
			</div>

			<vs-table
				:sst="true"
				:max-items="maxItems"
				@change-page="setPageNumber"
				@sort="sortTab"
				pagination
				:data="logslist"
				:currentPage="currentPage"
				:total="+totalLogs"
			>
				<template slot="thead">
					<vs-th
						v-for="fil in field"
						:key="fil.field"
						showSort
						class="text-capitalize"
						:style="`width: + ${fil.width}`"
						:class="{
							'justify-center':
								fil.align && fil.align === 'center'
						}"
						:keyForSorting="fil.field"
						@setSortKey="setSortKey"
					>
						{{ $capitalizeFirstLetter($t(fil.title)) }}
					</vs-th>
				</template>
				<template slot-scope="{ data }">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<template v-for="fil in field">
							<vs-td
								v-if="fil.field === 'created_at'"
								:style="`width: ${fil.width}`"
							>
								{{ tr.created_at || "---" }}
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'user_manager_id'"
								:style="`width: ${fil.width}`"
							>
								<router-link
									:to="`/manager/${tr.user_manager_id}`"
								>
									{{ getManagerName(tr) }}
								</router-link>
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'order_id'"
								:style="`width: ${fil.width}`"
							>
								<router-link
									v-if="tr.order_id"
									:to="`/ticket/${tr.order_id}`"
								>
									{{ tr.order_id }}
								</router-link>

								<span v-else>...</span>
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'chat'"
								:style="`width: ${fil.width}`"
							>
								<span
									:class="{ chat_empty: !getChatId(tr) }"
									class="chat"
									@click="openChat(tr)"
								>
									{{ getChatId(tr) || "..." }}
								</span>
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'site'"
								:style="`width: ${fil.width}`"
							>
								{{ tr.website_name || "..." }}
							</vs-td>

							<vs-td
								v-else-if="fil.field === 'info'"
								:style="`width: ${fil.width}`"
							>
								{{ getLogInfo(tr) }}
							</vs-td>
						</template>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</div>
</template>

<script>
import logsHeaders from "../assets/configs/logsHeaders";
import databaseManager from "../mixins/databaseManager.js";
import VSelect from "vue-select";

export default {
	name: "ManagersLogs",
	mixins: [databaseManager],

	components: {
		VSelect
	},

	data() {
		return {
			off: "",
			to: "",
			selectedManagers: [],
			managers: [],
			maxItems: 10,
			currentPage: 1,
			totalLogs: 1,
			logslist: [],
			sortType: null,
			sortKey: null,
			updatingInterval: null,
			orderId: "",
			selectedManagersActions: [],
			managersActions: [],
			totalActions: ""
		};
	},

	watch: {
		async selectedManagers(newVal, oldVal) {
			if (oldVal !== newVal) {
				await this.getManagersLogs();
				await this.getLogsCount();
			}
		},

		async selectedManagersActions(newVal, oldVal) {
			if (oldVal !== newVal) {
        const actions = this.selectedManagersActions
        const all = actions.find((el) => el.action === 'all')
        if (all && actions.length !== 1) {
          this.selectedManagersActions = actions.filter((el) => el.action !== 'all')
        } else if (!actions.length) {
          this.selectAllManagersActions()
        }
				await this.getManagersLogs();
				await this.getLogsCount();
			}
		},
		async maxItems(newVal) {
			if (newVal) {
				this.currentPage = 1;
				await this.getManagersLogs();
			}
		},
		async off(newVal) {
			if (newVal) {
				await this.getManagersLogs();
				await this.getLogsCount();
			}
		},
		async to(newVal) {
			if (newVal) {
				await this.getManagersLogs();
				await this.getLogsCount();
			}
		}
	},

	computed: {
		locale() {
			return this.$i18n.locale;
		},

    filteredActions() {
      return this.managersActions.filter((el) => el.show)
    }
	},

	created() {
		this.getManagers();
		const headers = logsHeaders.getHeaders();
		this.field = headers.field;
	},

	async mounted() {
		this.selectAllManagersActions();
		await this.getManagersActions();
		await this.getManagersLogs();
		await this.getLogsCount();

		this.updatingInterval = setInterval(
			async () => await this.getManagersLogs(),
			30000
		);
	},

	beforeDestroy() {
		clearInterval(this.updatingInterval);
		this.updatingInterval = null;
	},

	methods: {
    resetFilters() {
      this.off = ''
      this.to = ''
      this.orderId = ''
      this.selectAllManagers()
      this.selectAllManagersActions()
    },

		async searchById(e) {
			if ((e.length === 4 && !isNaN(e)) || e.length === 0) {
				this.currentPage = 1;
				await this.getManagersLogs();
			}
		},

		openChat(log) {
			if (!log) {
				return;
			}

			if (log.client_chat_id) {
				this.$store.dispatch("openChat", {
					id: log.order_id,
					userId: log.user_id,
					disabled: false
				});
			}

			if (log.author_chat_id) {
				this.$store.dispatch("openChat", {
					authorChatId: log.author_chat_id,
					orderId: log.order_id,
					disabled: false
				});
			}
		},

		getChatId(log) {
			return log.client_chat_id || log.author_chat_id;
		},

		setSortKey(key) {
			this.sortKey = key;
		},

		getLogInfo(item) {
      try {
        if (!item) {
          return ''
        }
        
        const info = item[`description_${this.locale}`]
        return info || ''
      } catch (err) {
        console.error(err);
      }
		},

		async sortTab(key, type) {
			this.sortType = type;
			await this.getManagersLogs();
		},

		async setPageNumber(data) {
			this.currentPage = data;
			await this.getManagersLogs();
		},

		async getManagers() {
			if (this.$store.getters.getRole === "admin") {
				try {
					let managers = (await this.$http.get(`admin/manager`)).data
						.data;
					this.managers = managers.map(d => ({
						name: d.first_name + " " + d.last_name,
						user_id: d.user_id,
						id: d.id
					}));
					this.selectAllManagers();
				} catch (e) {
					this.$vs.notify({
						title: "Error",
						text: e.message,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger"
					});
				}
			}
		},

		async getManagersActions() {
			try {
				const res = await this.dbGetManagersLogAction();
				this.managersActions = res.data;
			} catch (err) {
				console.error(err);
			}
		},

		async getLogsCount() {
      if (!this.managers.length || !this.managersActions.length) {
        return
      }

			const selectedActions = this.selectedManagersActions;

			const actions =
				selectedActions.length && selectedActions[0].action === "all"
					? this.managersActions.map(el => el.action)
					: selectedActions.map(el => el.action);

			let managers = this.selectedManagers.map(d => d.id);

			const body = {
				off: this.off,
				to: this.to,
				managers,
				orderId: this.orderId,
				actions
			};

			try {
				const res = await this.dbGetManagersLogCount(body);
				this.totalActions = res;
			} catch (err) {
				console.error(err);
			}
		},

		async getManagersLogs() {
      if (!this.managers.length || !this.managersActions.length) {
        return
      }

			const selectedActions = this.selectedManagersActions;
			const actions =
				selectedActions.length && selectedActions[0].action === "all"
					? this.managersActions.map(el => el.action)
					: selectedActions.map(el => el.action);

			const offset = (this.currentPage - 1) * this.maxItems;
			let managers = this.selectedManagers.map(d => d.id);

			const requestOptions = {
				off: this.off,
				to: this.to,
				limit: this.maxItems,
				offset: offset,
				sortType: this.sortType,
				sortKey: this.sortKey,
				orderId: this.orderId,
				managers,
				actions
			};

			try {
				const res = await this.dbGetManagersLogs(requestOptions);
				this.totalLogs = res.count;
				this.logslist = [];
				if (res.data === null) {
					return;
				}

				for (let i = 0; i < offset; i++) {
					this.$set(this.logslist, i, res.data[0]);
				}

				for (let i = 0; i < res.data.length; i++) {
					this.$set(this.logslist, offset + i, res.data[i]);
				}
			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger"
				});
			}
		},

		cleanSelectedManagers() {
			this.selectedManagers = [];
		},

		selectAllManagers() {
			this.selectedManagers = this.managers;
		},

		cleanSelectedManagersActions() {
			this.selectedManagersActions = [];
		},

		selectAllManagersActions() {
			// this.selectedManagersActions = this.managersActions
			this.cleanSelectedManagersActions();
			this.selectedManagersActions.push({
				action: "all",
				title: this.$t("all")
			});
		},

		getManagerName(item) {
			if (item) {
				return `${item.user_manager_first_name} ${item.user_manager_last_name}`;
			}
			return "...";
		}
	}
};
</script>

<style lang="scss">
.actions-select {
	.vs__dropdown-toggle {
		overflow: auto;
		--vs-dropdown-max-height: 95px;
	}
}

.datepicker-widget-block {
	.datepickers {
		width: 75%;

		@media screen and (max-width: 992px) {
			width: 100%;
		}
	}

	.info-card {
    &__title {
      white-space: nowrap;;
    }

		&_green {
			color: #54ad32;
		}

		&__value {
			font-size: 21px;
			font-weight: 600;
		}

		.icon {
			display: flex;
			align-items: center;
			padding: 13px;
			border-radius: 10px;
			font-size: 20px;

			svg {
				width: 27px;
				height: 27px;
			}

			&_green {
				color: rgb(58, 196, 125);
				background-color: #e4f6ed;
			}
		}
	}
}

.vs__dropdown-menu {
	min-width: fit-content;
}

.logs {
	.table {
		.vs-con-table .vs-con-tbody {
			padding: 10px;
			border: 0;
			background-color: transparent;
		}

		.vs-table {
			tr {
				border-top: 1px solid #cfcfcf;

				&:last-child {
					border-bottom: 1px solid #cfcfcf;
				}
			}
		}

		.chat {
			color: rgba(var(--vs-primary), 1);
			cursor: pointer;

			&_empty {
				color: inherit;
				cursor: default;
			}
		}
	}

	.perPage {
		width: 68px;
		flex: 0 0 auto;

		.vs__dropdown-toggle {
			border-radius: 100px;
		}

		.vs__clear {
			display: none;
		}

		.vs__search {
			padding: 0;
		}

		.v-select__selection {
			width: 100%;
			justify-content: center;
		}

		.vs__selected-options {
			padding-left: 13px;
			flex-wrap: nowrap;

			.vs__selected {
				padding: 0;
				flex: 0 0 auto;
				padding: 0;
			}
		}
	}
}

.search {
	position: relative;

	.search-icon {
		background: rgba(var(--vs-primary), 1);
		cursor: pointer;
		right: 0;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		height: 100%;
		width: 35px;
		position: absolute;
		top: 0;
		color: white !important;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		font-size: 22px;
	}
}
</style>
